(function () {
  'use strict';

  function initMarquee(root) {
    var hoverPause = root.dataset.hoverPause === 'true';

    if (hoverPause) {
      root.addEventListener('mouseenter', function () {
        root.classList.add('is-paused');
      });
      root.addEventListener('mouseleave', function () {
        root.classList.remove('is-paused');
      });

      // Touch devices: pause briefly on tap for readability, then resume.
      root.addEventListener(
        'touchstart',
        function () {
          root.classList.add('is-paused');
          window.clearTimeout(root._bisTouchTimer);
          root._bisTouchTimer = window.setTimeout(function () {
            root.classList.remove('is-paused');
          }, 1800);
        },
        { passive: true }
      );
    }

    // Pause animation while the section is off-screen to save CPU/GPU.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.remove('is-offscreen');
            } else {
              root.classList.add('is-offscreen');
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(root);
    }
  }

  function init() {
    var marquees = document.querySelectorAll('[data-bis-marquee]');
    marquees.forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the section is added/updated in the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-bis-marquee]');
    if (root) initMarquee(root);
  });
})();
